import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import {
  API_GET_CYCLE_PAYOUT_HISTORY,
  API_GET_REAL_ESTATE_PAYOUT_HISTORY,
} from "../../../config/api";

export const getRealEstatePayoutHistory = createAsyncThunk(
  "realEstatePayout/getHistory",
  async ({ id, cycle_id, callback, fail }, { rejectWithValue }) => {
    try {
      // A product holds several cycles (campaigns). With a cycle on screen,
      // ask for that cycle directly; the product endpoint returns every cycle
      // of the product and is only correct when there is no cycle.
      const path = cycle_id
        ? API_GET_CYCLE_PAYOUT_HISTORY(cycle_id)
        : API_GET_REAL_ESTATE_PAYOUT_HISTORY + id;

      const response = await Client({
        method: "GET",
        path,
      });

      callback?.(response?.data?.data);
      return response?.data?.data;
    } catch (error) {
      fail?.(error?.response?.data?.status);

      const msg = proccessErrorMessage(error);
      //   toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
